import React from "react";
import cl from "./Header.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";

const Header = (props) => {
  const { cartItems } = props;

  const navigate = useNavigate();

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      navigate("/search");
    }
  };

  const [mobileMenu, setMobileMenu] = useState(cl.mobile_header_links_hidden);
  const [mobileMenuIcon, setMobileMenuIcon] = useState(cl.mobile_menu_icon);
  const [mobileCloseIcon, setMobileCloseIcon] = useState(
    cl.mobile_close_icon_hidden
  );
  let onMenuClick = () => {
    setMobileMenu(cl.mobile_header_links);
    setMobileMenuIcon(cl.mobile_menu_icon_hidden);
    setMobileCloseIcon(cl.mobile_close_icon);
    document.body.classList.add("modal-open");
  };
  let onCloseClick = () => {
    setMobileMenu(cl.mobile_header_links_hidden);
    setMobileMenuIcon(cl.mobile_menu_icon);
    setMobileCloseIcon(cl.mobile_close_icon_hidden);
    document.body.classList.remove("modal-open");
  };
  let onSearchChange = (e) => {
    let text = e.target.value;
    props.updateNewSearchText(text);
  };
  let onSearchClick = () => {};

  return (
    <header
      className={cl.container}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "0 20px",
      }}
    >
      <NavLink
        className={cl.footer_link}
        to=""
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textDecoration: "none",
        }}
      >
        <svg
          preserveAspectRatio="xMidYMid meet"
          data-bbox="19 59.574 162 80.852"
          viewBox="19 59.574 162 80.852"
          height="70"
          width="70"
          xmlns="http://www.w3.org/2000/svg"
          data-type="color"
          role="img"
          aria-label="Homepage"
        >
          <defs></defs>
          <g>
            <path
              d="M20 140.426h-.015a1 1 0 0 1-.985-1.014c.304-21.392 8.864-41.455 24.104-56.494C58.36 67.864 78.565 59.574 100 59.574c21.432 0 41.636 8.288 56.891 23.338 15.239 15.035 23.802 35.094 24.109 56.482a1 1 0 0 1-.985 1.014c-.566-.016-1.007-.434-1.015-.986-.3-20.859-8.651-40.423-23.515-55.087C140.607 69.658 120.902 61.574 100 61.574c-20.905 0-40.612 8.085-55.491 22.767C29.645 99.009 21.296 118.577 21 139.44a1 1 0 0 1-1 .986z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M100 131.326a1 1 0 0 1-1-1V60.574a1 1 0 1 1 2 0v69.752a1 1 0 0 1-1 1z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M101.757 131.5a1 1 0 0 1-.981-1.195l13.608-68.412a1 1 0 1 1 1.961.39l-13.608 68.412a1.001 1.001 0 0 1-.98.805z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M103.445 132.012a1 1 0 0 1-.924-1.384l26.692-64.443a1 1 0 0 1 1.848.766l-26.692 64.443a1 1 0 0 1-.924.618z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M105 132.843a.999.999 0 0 1-.83-1.555l38.753-57.997a1 1 0 1 1 1.662 1.111l-38.753 57.997a.995.995 0 0 1-.832.444z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M106.365 133.963a.999.999 0 0 1-.707-1.707l49.322-49.322a.999.999 0 1 1 1.414 1.414l-49.322 49.322a.997.997 0 0 1-.707.293z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M107.486 135.327a.999.999 0 0 1-.557-1.831l57.996-38.752a.999.999 0 1 1 1.112 1.663l-57.996 38.752a1.005 1.005 0 0 1-.555.168z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M108.317 136.884a1 1 0 0 1-.383-1.925l64.442-26.693a1.001 1.001 0 0 1 .766 1.848L108.7 136.807a.996.996 0 0 1-.383.077z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M108.828 138.572a1 1 0 0 1-.194-1.981l68.412-13.608a1 1 0 0 1 .391 1.962l-68.412 13.608a1.026 1.026 0 0 1-.197.019z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M179.986 140.329h-70.984a1 1 0 1 1 0-2h70.984a1 1 0 1 1 0 2z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M90.998 140.329H20.036a1 1 0 1 1 0-2h70.962a1 1 0 1 1 0 2z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M109.002 140.329a1 1 0 0 1-1-1c0-4.413-3.59-8.002-8.002-8.002s-8.002 3.59-8.002 8.002a1 1 0 1 1-2 0c0-5.515 4.487-10.002 10.002-10.002s10.002 4.487 10.002 10.002a1 1 0 0 1-1 1z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M91.172 138.572c-.064 0-.13-.006-.196-.019l-68.412-13.608a1 1 0 1 1 .391-1.962l68.412 13.608a1 1 0 0 1-.195 1.981z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M91.684 136.884a.996.996 0 0 1-.383-.077l-64.442-26.693a1 1 0 0 1 .766-1.848l64.442 26.693a1 1 0 0 1-.383 1.925z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M92.515 135.327c-.19 0-.384-.055-.555-.168L33.963 96.407a1 1 0 1 1 1.112-1.663l57.997 38.752a.999.999 0 0 1-.557 1.831z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M93.635 133.963a.997.997 0 0 1-.707-.293L43.605 84.348a.999.999 0 1 1 1.414-1.414l49.322 49.322a.999.999 0 0 1-.706 1.707z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M95 132.843a.998.998 0 0 1-.832-.444L55.416 74.402a.999.999 0 1 1 1.662-1.111l38.752 57.997a.999.999 0 0 1-.83 1.555z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M96.555 132.012a1 1 0 0 1-.924-.618L68.938 66.952a1.001 1.001 0 0 1 1.848-.766l26.692 64.443a1.001 1.001 0 0 1-.923 1.383z"
              fill="#021A4A"
              data-color="1"
            ></path>
            <path
              d="M98.243 131.5a.998.998 0 0 1-.979-.805L83.655 62.283a1 1 0 1 1 1.961-.39l13.608 68.412a1 1 0 0 1-.981 1.195z"
              fill="#021A4A"
              data-color="1"
            ></path>
          </g>
        </svg>
        <h1
          style={{
            textDecoration: "none",
            fontSize: "24px",
          }}
          className={cl.headerTitle}
        >
          {props.aboutData.shopName}
        </h1>
      </NavLink>

      <div
        className={cl.search_bar}
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
        >
          <NavLink to="search">
            <button className={cl.search_bar_button} onClick={onSearchClick}>
              <svg
                className={cl.search_bar_button_svg}
                height="50px"
                viewBox="0 0 50 50"
                width="50px"
              >
                <rect fill="none" />
                <circle
                  cx="21"
                  cy="20"
                  fill="none"
                  r="16"
                  stroke="#000000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="2"
                />
                <line
                  fill="none"
                  stroke="#000000"
                  strokeMiterlimit="10"
                  strokeWidth="4"
                  x1="32.229"
                  x2="45.5"
                  y1="32.229"
                  y2="45.5"
                />
              </svg>
            </button>
          </NavLink>
          <input
            type="text"
            value={props.productsPage.newSearchText}
            onChange={onSearchChange}
            onKeyPress={handleKeyPress}
            placeholder="Ricerca..."
            className={cl.input}
          ></input>
        </div>
        <div
          style={{
            width: "61vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div className={cl.bottom_line_links}>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to=""
            >
              Casa
            </NavLink>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to="/about"
            >
              Chi siamo
            </NavLink>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to="/products"
            >
              Prodotti
            </NavLink>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to="/contacts"
            >
              Contatti
            </NavLink>
          </div>
          <svg
            onClick={onMenuClick}
            className={mobileMenuIcon}
            height="30px"
            viewBox="0 0 512 512"
            style={{ zIndex: "1000" }}
          >
            <title />
            <g data-name="1" id="_1">
              <path d="M441.13,166.52h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
              <path d="M441.13,279.72h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
              <path d="M441.13,392.92h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
            </g>
          </svg>
          <svg
            onClick={onCloseClick}
            className={mobileCloseIcon}
            height="24px"
            id="Layer_1"
            version="1.1"
            viewBox="0 0 32 32"
            width="24px"
            style={{ zIndex: "1000" }}
          >
            <g>
              <polyline
                fill="none"
                points="   649,137.999 675,137.999 675,155.999 661,155.999  "
                stroke="#FFFFFF"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="2"
              />
              <polyline
                fill="none"
                points="   653,155.999 649,155.999 649,141.999  "
                stroke="#FFFFFF"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="2"
              />
              <polyline
                fill="none"
                points="   661,156 653,162 653,156  "
                stroke="#FFFFFF"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="2"
              />
            </g>
            <g>
              <path d="M11.312,12.766c0.194,0.195,0.449,0.292,0.704,0.292c0.255,0,0.51-0.097,0.704-0.292c0.389-0.389,0.389-1.02,0-1.409   L4.755,3.384c-0.389-0.389-1.019-0.389-1.408,0s-0.389,1.02,0,1.409L11.312,12.766z" />
              <path d="M17.407,16.048L28.652,4.793c0.389-0.389,0.389-1.02,0-1.409c-0.389-0.389-1.019-0.561-1.408-0.171L15.296,15   c0,0-0.296,0-0.296,0s0,0.345,0,0.345L3.2,27.303c-0.389,0.389-0.315,1.02,0.073,1.409c0.194,0.195,0.486,0.292,0.741,0.292   s0.528-0.097,0.722-0.292L15.99,17.458l11.249,11.255c0.194,0.195,0.452,0.292,0.706,0.292s0.511-0.097,0.705-0.292   c0.389-0.389,0.39-1.02,0.001-1.409L17.407,16.048z" />
            </g>
          </svg>
          <div>
            <NavLink
              className={(headerData) =>
                headerData.isActive
                  ? cl.header_link_active_cart
                  : cl.header_link_cart
              }
              to="/cart"
            >
              <div className={cl.cart_items}>
                <p>Carrello</p>
                <p className={cl.cart_items_number}>({cartItems.length})</p>
              </div>
            </NavLink>
          </div>
        </div>
      </div>

      <div className={mobileMenu}>
        <NavLink className={cl.mobile_link} to="/" onClick={onCloseClick}>
          Casa
        </NavLink>
        <NavLink className={cl.mobile_link} to="/about" onClick={onCloseClick}>
          Chi siamo
        </NavLink>
        <NavLink
          className={cl.mobile_link}
          to="/products"
          onClick={onCloseClick}
        >
          Prodotti
        </NavLink>
        <NavLink
          className={cl.mobile_link}
          to="/contacts"
          onClick={onCloseClick}
        >
          Contatti
        </NavLink>
      </div>
    </header>
  );
};

export default Header;
